import { History, Location } from 'history';

import { updateSearch } from 'bernie-core';

export interface CloseDialogsInputs {
  history: History;
  location: Location;
  callback?: () => void;
}

export const closeDialogs = ({ history, location, callback }: CloseDialogsInputs) => {
  const { search } = location;

  const urlSearchParams = new URLSearchParams(search);

  if (urlSearchParams.get('pwaDialog')) {
    updateSearch({
      history,
      location,
      newParams: {},
      paramsFilter: param => param !== 'pwaDialog' && param !== 'pwaDialogNested',
      replace: true
    });
  }

  if (callback) {
    /*
     * This callback has to be executed inside a timeout as bernie closes the dialogs by going back in the history
     * if we don't wait for this we could do something before the dialog is closed.
     * Known issue example: Change the URL from a dialog and then close dialog.
     * If the timeout isn't in place then bernie will revert the latest URL change as that was the previous URL state before opening the dialog
     */

    setTimeout(() => callback(), 10);
  }
};
